import { useState } from "react";
import { toast } from "react-toastify";


const BASE_URL = process.env.REACT_APP_BASE_URL;
const EducationForm = ({ onClose, onSave, initialData, title }) => {
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});

  const [formData, setFormData] = useState(() => ({
    school: initialData?.school || "",
    degree: initialData?.degree || "",
    field: initialData?.field_study || "",
    start_Year: initialData?.start_Year || "",
    end_Year: initialData?.end_Year || "",
    start_month: initialData?.start_month || "",
    end_month: initialData?.end_month || "",
    grade: initialData?.grade || "",
    description: initialData?.description || "",
    skills: initialData?.skills || [],
    newSkill: "",
    media: initialData?.media || null,
    currentlyStudying: initialData?.currentlyStudying || false,
  }));

  const handleChange = (e) => {
    const { name, value, type, files } = e.target;
    let newErrors = { ...errors };

    if (name === "start_Year" || name === "end_Year") {
      if (!/^\d{0,4}$/.test(value)) {
        newErrors[name] = "Must be a 4-digit year";
      } else {
        delete newErrors[name];
      }

      if (name === "end_Year" && value && formData.start_Year) {
        if (parseInt(value) < parseInt(formData.start_Year)) {
          newErrors[name] = "End year must be after start year";
        } else {
          delete newErrors[name];
        }
      }
    }

    setErrors(newErrors);
    if (type === "file") {
      setFormData({ ...formData, media: files[0] });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };
  const addSkill = () => {
    const regex = /^[a-zA-Z0-9\s.+#-]+$/;
    if(!formData.newSkill.trim())
    {
      toast.error('Please skill required or not empty')
      return;
    }
   if (!regex.test(formData.newSkill)) {
  toast.error('Enter Valid Skill');
  return;
}
    if (formData.newSkill.trim()) {
      setFormData((prev) => ({
        ...prev,
        skills: [...prev.skills, prev.newSkill.trim()],
        newSkill: "",
      }));
    }
  };
  const handleSubmit = async (e) => {
    e.preventDefault();

    const token =
      localStorage.getItem("access_token") || localStorage.getItem("access");

    const isEdit = !!initialData?.id;
    if(!formData.school)
    {
      toast.error('School is required')
      return;
    }
    if(!formData.degree)
    {
      toast.error('Degree is required')
      return;
    }
    const formPayload = new FormData();
    formPayload.append("school", formData.school);
    formPayload.append("degree", formData.degree);
    formPayload.append("field_study", formData.field);
    formPayload.append("start_Year", formData.start_Year);
    formPayload.append("end_Year", formData.end_Year);
    formPayload.append("grade", formData.grade);
    formPayload.append("description", formData.description);

    if (formData.start_month) {
      formPayload.append("start_month", formData.start_month);
    }
    if (formData.end_month) {
      formPayload.append("end_month", formData.end_month);
    }

    if (formData.media && typeof formData.media !== "string") {
      formPayload.append("media", formData.media);
    }

    if (formData.skills.length > 0) {
      formData.skills.forEach((skill) => {
        formPayload.append("skills", skill);
      });
    }

    if (isEdit) {
      formPayload.append("id", initialData.id);
    }
    try {
      setLoading(true);
      const response = await fetch(`${BASE_URL}/user/portfolio/education/`, {
        method: isEdit ? "PATCH" : "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "x-api-key": process.env.REACT_APP_X_API_KEY
        },
        body: formPayload,
      });

      if (!response.ok) {
        const errData = await response.json();
        console.error("API error:", errData);
        throw new Error("Failed to save education");
      }
      const result = await response.json();
      console.log("Education saved:", result);
      onSave(result?.data || result);
      onClose();
    } catch (error) {
      console.error("Error submitting form:", error);
      console.error("Failed to submit education");
    } finally {
      setLoading();
    }
  };

  return (
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50 p-4">
  <div className="mt-12 bg-white w-full max-w-2xl rounded-2xl shadow-xl max-h-[90vh] overflow-y-auto">
    {/* Modal Header */}
    <div className="p-6 border-b border-gray-100">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 bg-[#e8f0f7] rounded-lg flex items-center justify-center">
            <svg className="w-5 h-5 text-[#0f6abf]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 14l9-5-9-5-9 5 9 5z" />
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 14l9-5-9-5-9 5 9 5z" />
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 18v-6a9 9 0 0118 0v6" />
            </svg>
          </div>
          <h2 className="text-lg font-semibold text-gray-900">{title}</h2>
        </div>
        <button
          onClick={onClose}
          className="w-10 h-10 flex items-center justify-center rounded-xl hover:bg-gray-100 transition-colors"
        >
          <svg className="w-5 h-5 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>
    </div>
    {/* Modal Body */}
    <div className="p-6">
      <form
        className="w-full max-w-[600px] box-border space-y-4"
        onSubmit={handleSubmit}
      >
        {/* School */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">School *</label>
          <input
            type="text"
            name="school"
            value={formData.school}
            onChange={handleChange}
            required
            className="w-full px-4 py-3 border border-gray-300 rounded-xl text-sm text-gray-900 focus:outline-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all"
          />
        </div>

        {/* Degree */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">Degree *</label>
          <input
            type="text"
            name="degree"
            value={formData.degree}
            onChange={handleChange}
            required
            className="w-full px-4 py-3 border border-gray-300 rounded-xl text-sm text-gray-900 focus:outline-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all"
          />
        </div>

        {/* Field of Study */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">Field of Study</label>
          <input
            type="text"
            name="field"
            value={formData.field}
            onChange={handleChange}
            className="w-full px-4 py-3 border border-gray-300 rounded-xl text-sm text-gray-900 focus:outline-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all"
          />
        </div>

        {/* Start / End Year */}
        <div className="grid grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Start Year</label>
            <input
              type="text"
              name="start_Year"
              value={formData.start_Year}
              onChange={handleChange}
              className="w-full px-4 py-3 border border-gray-300 rounded-xl text-sm text-gray-900 focus:outline-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all"
            />
            {errors.start_Year && (
              <p className="text-xs text-red-500 mt-1">
                {errors.start_Year}
              </p>
            )}
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">End Year</label>
            <input
              type="text"
              name="end_Year"
              value={formData.end_Year}
              onChange={handleChange}
              className="w-full px-4 py-3 border border-gray-300 rounded-xl text-sm text-gray-900 focus:outline-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all"
            />
            {errors.end_Year && (
              <p className="text-xs text-red-500 mt-1">
                {errors.end_Year}
              </p>
            )}
          </div>
        </div>

        {/* Grade */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">Grade</label>
          <input
            type="number"
            name="grade"
            value={formData.grade}
            onChange={handleChange}
            className="w-full px-4 py-3 border border-gray-300 rounded-xl text-sm text-gray-900 focus:outline-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all"
          />
        </div>

        {/* Skills */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">Skills</label>
          <div className="flex gap-2">
            <input
              type="text"
              name="newSkill"
              value={formData.newSkill}
              onChange={handleChange}
              placeholder="Add skill"
              className="flex-1 px-4 py-3 border border-gray-300 rounded-xl text-sm text-gray-900 focus:outline-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all"
            />
            <button
              type="button"
              onClick={addSkill}
              className="w-12 h-12 border border-gray-300 rounded-xl flex items-center justify-center hover:bg-gray-50 transition-colors"
            >
              <svg className="w-5 h-5 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4v16m8-8H4" />
              </svg>
            </button>
          </div>

          <div className="flex flex-wrap gap-2 mt-2">
            {formData.skills.map((skill, idx) => (
              <span key={idx} className="px-3 py-1.5 bg-[#e8f0f7] text-[#0f6abf] text-sm font-medium rounded-lg">
                {skill}
              </span>
            ))}
          </div>
        </div>

        {/* Media */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">Media</label>

          {formData.media && typeof formData.media === "string" && (
            <div className="mb-3 p-3 bg-gray-50 rounded-xl">
              <a
                href={formData.media}
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#0f6abf] hover:underline text-sm"
              >
                View Uploaded Media
              </a>
              <p className="text-xs text-gray-500 mt-1">
                Uploading a new file will replace the existing one.
              </p>
            </div>
          )}

          <div className="relative">
            <input
              type="file"
              name="media"
              onChange={handleChange}
              className="absolute inset-0 w-full h-full opacity-0 cursor-pointer z-10"
            />
            <div className="border-2 border-dashed border-gray-300 rounded-xl p-6 text-center hover:border-[#0f6abf] hover:bg-[#e8f0f7]/10 transition-colors">
              <div className="w-12 h-12 bg-[#e8f0f7] rounded-lg flex items-center justify-center mx-auto mb-3">
                <svg className="w-5 h-5 text-[#0f6abf]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                </svg>
              </div>
              <p className="text-sm text-gray-600">Click to upload media</p>
              <p className="text-xs text-gray-500 mt-1">PNG, JPG, PDF up to 5MB</p>
            </div>
          </div>

          {formData.media && typeof formData.media !== "string" && (
            <div className="mt-3 p-3 bg-gray-50 rounded-xl">
              <p className="text-sm text-gray-700">
                Selected: <span className="font-medium">{formData.media.name}</span>
              </p>
            </div>
          )}
        </div>

        {/* Description */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">Description</label>
          <textarea
            name="description"
            value={formData.description}
            onChange={handleChange}
            className="w-full px-4 py-3 border border-gray-300 rounded-xl text-sm text-gray-900 focus:outline-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all resize-none min-h-[100px]"
          />
        </div>

        {/* Actions */}
        <div className="pt-6 border-t border-gray-100">
          <div className="flex justify-end gap-3">
            <button
              type="button"
              onClick={onClose}
              className="px-5 py-2.5 text-gray-700 font-medium rounded-xl hover:bg-gray-100 transition-colors"
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={Object.keys(errors).length > 0}
              className="px-5 py-2.5 bg-[#0f6abf] text-white font-medium rounded-xl hover:bg-[#0a5ca8] transition-colors disabled:opacity-50 flex items-center gap-2"
            >
              {loading ? (
                <>
                  <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                  Saving...
                </>
              ) : (
                <>
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                  </svg>
                  Save Education
                </>
              )}
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
  );
};

export default EducationForm;
